export const LeftArrow = ({ stroke = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <g clipPath="url(#clip0_11973_441)">
        <path
          d="M15.8333 10.208H4.16666"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16666 15.208L4.16666 10.208"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16666 5.20801L4.16666 10.208"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11973_441">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.208008)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
